import React from "react";

function NotFound() {
  return (
    <div>
      <h6>Page Not found</h6>
    </div>
  );
}

export default NotFound;
